export default __webpack_public_path__ + "static/img-2-a9a9720b0ba0493e15c5e186ebf2293a.png";